import { render, staticRenderFns } from "./KD2.vue?vue&type=template&id=13cc10bb"
import script from "./KD2.vue?vue&type=script&lang=js"
export * from "./KD2.vue?vue&type=script&lang=js"
import style0 from "./KD2.vue?vue&type=style&index=0&id=13cc10bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports